import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { VscSettingsGear } from "react-icons/vsc";
import SingleLoaderItem from "../Loaders/SingleLoaderItem";
import { useParams } from "react-router-dom";
import MandatorySign from "../Components/MandatorySign";
import { useLanguage } from "../Translations/LenguageContext";

const AIChatSidebar = ({
    account_id,
    selectedModelTitle,
    selectedModel,
    setTemperature,
    temperature,
    toggleSidebar,
    sidebarOpen,
    reasoningDepth,
    setReasoningDepth,
    isSearchEnabled,
    setIsSearchEnabled,
    isMemoryEnabled,
    setIsMemoryEnabled,
    isJsonMode,
    setIsJsonMode,
    setOpenSidebarRight,
    setOpenPoolerSidebar,
    mcpData,
    connectors,
    setConnectors,
    fetchMcpData,
    loadingMcpData,
    setOpenSystemInstruction,
    selectedSystemInstructions,
    setOpenAbilitiesModal
}) => {
    const { t } = useLanguage()
    const { org_id } = useParams()

    useEffect(() => {
        localStorage.setItem("ai_selected_model", JSON.stringify(selectedModel));
    }, [selectedModel]);

    useEffect(() => {
        localStorage.setItem("ai_selected_model_title", selectedModelTitle);
    }, [selectedModelTitle]);

    useEffect(() => {
        localStorage.setItem("ai_temperature", temperature);
    }, [temperature]);

    useEffect(() => {
        localStorage.setItem("ai_reasoning_depth", reasoningDepth);
    }, [reasoningDepth]);

    useEffect(() => {
        localStorage.setItem("ai_is_memory_enabled", isMemoryEnabled);
    }, [isMemoryEnabled]);

    useEffect(() => {
        localStorage.setItem("ai_is_search_enabled", isSearchEnabled);
    }, [isSearchEnabled]);

    useEffect(() => {
        localStorage.setItem("ai_is_json_mode", isJsonMode);
    }, [isJsonMode]);

    useEffect(() => {
        fetchMcpData(org_id);
    }, [account_id]);

    return (
        <div className={`right_sidebar_chat ${sidebarOpen ? "" : "right_sidebar_chat_closed"}`}>
            <div className={`right_sidebar_chat_inner ${sidebarOpen ? "" : "right_sidebar_chat_inner_closed"}`}>

                <div className="right_sidebar_chat_header">
                    <span><i><VscSettingsGear /></i> {t.playground.ai_settings}</span>
                    <button className="main_mcp_cont_chat_btn" onClick={toggleSidebar}><i className="fa-solid fa-x"></i></button>
                </div>

                <div className="right_sidebar_chat_body">
                    <button
                        className="sidebar_choise_btn"
                        onClick={() => setOpenPoolerSidebar(true)}
                    >
                        <span className="sidebar_choise_btn_title sidebar_choise_btn_title_item">{selectedModel.name} <span className="inference_provider">{selectedModel.inference_provider}</span></span>
                        <span className="sidebar_choise_btn_description">
                            {selectedModel.description}
                        </span>
                    </button>
                    {/* <button
                        key={selectedModel.id}
                        className="sidebar_choise_btn"
                        onClick={() => setOpenSidebarRight(true)}
                    >
                        <span className="sidebar_choise_btn_title sidebar_choise_btn_title_item">{selectedModel.name} <span className="inference_provider">{selectedModel.inference_provider}</span></span>
                        <span className="sidebar_choise_btn_description">
                            {selectedModel.description}
                        </span>
                    </button> */}

                    <button className={`sidebar_choise_btn ${selectedSystemInstructions && "sidebar_choise_btn_selected"}`} onClick={() => setOpenSystemInstruction(true)}>
                        {selectedSystemInstructions ? (
                            <>
                                <span className="sidebar_choise_btn_title">{selectedSystemInstructions.title}</span>
                                <span className="sidebar_choise_btn_description">
                                    {selectedSystemInstructions.instruction}
                                </span>
                            </>
                        ) : (
                            <>
                                <span className="sidebar_choise_btn_title">{t.playground.sys_instructions}</span>
                                <span className="sidebar_choise_btn_description">
                                    {t.playground.sys_desc}
                                </span>
                            </>
                        )}


                    </button>

                    <label className="sidebar_choise_btn_title">{t.playground.temperature}</label>
                    <div>
                        <div className="range_input_wrapper_cont">
                            <div className="range_input_wrapper">
                                <input
                                    type="range"
                                    className="temp_line_drag"
                                    min="0"
                                    max="2"
                                    step="0.1"
                                    value={temperature}
                                    style={{ "--progress": `${(temperature / 2) * 100}%` }}
                                    onChange={(e) => setTemperature(parseFloat(e.target.value))}
                                />
                            </div>
                            {/* <input
                        type="number"
                        className="slider_range_labels"
                        value={temperature}
                        onChange={(e) => setTemperature(parseFloat(e.target.value) || 0)}
                    /> */}
                            <div className="slider_range_labels">
                                {temperature}
                            </div>
                        </div>
                    </div>

                    <div className="sidebar_label_wrapper">
                        <label className="sidebar_choise_btn_title">{t.playground.reasoning_depth}</label>
                        <Dropdown autoClose={true}>
                            <Dropdown.Toggle as="button" className="sidebar_playground_select fade-in">
                                {reasoningDepth.charAt(0).toUpperCase() + reasoningDepth.slice(1) || "Select Depth"}
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="custom_dropdown_menu">
                                <div className="dropdown_container fade-in">
                                    {["off", "low", "medium", "high"].map((level) => (
                                        <Dropdown.Item
                                            key={level}
                                            className={`settings_link ${reasoningDepth === level ? "settings_link_selected" : ""}`}
                                            onClick={() => setReasoningDepth(level)}
                                        >
                                            {level.charAt(0).toUpperCase() + level.slice(1)}
                                        </Dropdown.Item>
                                    ))}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>

                    <p className="sidebar_label_subsection">{t.sidebar.abilities}</p>

                    <button className="sidebar_btn_ab" onClick={() => setOpenAbilitiesModal(true)}>{t.playground.open_abilities}</button>

                    <div className="sidebar_label_wrapper_row">
                        <label className="sidebar_choise_btn_title" htmlFor="web-search-toggle">
                            {t.playground.memory}
                            <span>
                                <MandatorySign message={t.playground.memory_mex} icon="info" />
                            </span>
                        </label>
                        <label className="switch_container">
                            <input
                                id="web-search-toggle"
                                type="checkbox"
                                checked={isMemoryEnabled}
                                onChange={() => setIsMemoryEnabled(!isMemoryEnabled)}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    <div className="sidebar_label_wrapper_row">
                        <label className="sidebar_choise_btn_title" htmlFor="web-search-toggle">
                            {t.playground.web_search}
                        </label>
                        <label className="switch_container">
                            <input
                                id="web-search-toggle"
                                type="checkbox"
                                checked={isSearchEnabled}
                                onChange={() => setIsSearchEnabled(!isSearchEnabled)}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    <div className="sidebar_label_wrapper_row">
                        <label className="sidebar_choise_btn_title" htmlFor="json-mode-toggle">
                            {t.playground.json_mode}
                        </label>
                        <label className="switch_container">
                            <input
                                id="json-mode-toggle"
                                type="checkbox"
                                checked={isJsonMode}
                                onChange={() => setIsJsonMode(!isJsonMode)}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>

                    {loadingMcpData ? (
                        <div>
                            <SingleLoaderItem length={2} />
                        </div>
                    ) : (
                        mcpData
                            .filter((mcp) => mcp.is_connected === true)
                            .map((mcp) => {
                                const isChecked = connectors.some(conn => conn.id === mcp.id);

                                const handleToggle = () => {
                                    if (isChecked) {
                                        setConnectors(connectors.filter((conn) => conn.id !== mcp.id));
                                    } else {
                                        const newConnector = {
                                            id: mcp.id,
                                            name: mcp.name,
                                            type: mcp.type || 'mcp'
                                        };
                                        setConnectors([...connectors, newConnector]);
                                    }
                                };

                                return (
                                    <div className="sidebar_label_wrapper_row fade-in" key={mcp.id}>
                                        <label className="sidebar_choise_btn_title" htmlFor={mcp.id}>
                                            <span className="sidebar_choise_btn_title_span">
                                                {mcp.name}
                                                {mcp.tag && (
                                                    <span className="model_name_tag">{mcp.tag}</span>
                                                )}
                                            </span>
                                            {mcp.is_version_different && (
                                                <span className="version_alert">
                                                    <MandatorySign message={"The deployed version and your connected version differ. We recommend reconnecting to sync them."} icon="info" />
                                                </span>
                                            )}
                                        </label>
                                        <label className="switch_container">
                                            <input
                                                id={mcp.id}
                                                type="checkbox"
                                                checked={isChecked}
                                                onChange={handleToggle}
                                            />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                );
                            })
                    )}

                    <p className="right_sidebar_chat_body_last_message">{t.playground.ls_mex}</p>
                </div>
            </div>

        </div>
    );
};

export default AIChatSidebar;